import { IAppointmentTypeWaitTimeStats } from '../charts/WaitTimeChart';

export interface WaitTimeSummaryMetrics {
  totalAppointments: number;
  averageWaitDays: number;
  medianWaitDays: number;
  overOneMonthPercent: number;
}

export function computeWaitTimeSummary(
  stats: IAppointmentTypeWaitTimeStats[] = [],
): WaitTimeSummaryMetrics {
  if (!stats.length) {
    return {
      totalAppointments: 0,
      averageWaitDays: 0,
      medianWaitDays: 0,
      overOneMonthPercent: 0,
    };
  }

  const totalAppointments = stats.reduce((sum, item) => sum + item.totalAppointments, 0);
  const weightedAverage = totalAppointments > 0
    ? stats.reduce((sum, item) => sum + item.avgWaitTime * item.totalAppointments, 0) / totalAppointments
    : 0;
  const weightedMedian = totalAppointments > 0
    ? stats.reduce((sum, item) => sum + item.medianWaitTime * item.totalAppointments, 0) / totalAppointments
    : 0;
  const overOneMonth = stats.reduce(
    (sum, item) => sum + (item.waitTimeDistribution?.overMonth || 0),
    0,
  );

  return {
    totalAppointments,
    averageWaitDays: Number(weightedAverage.toFixed(1)),
    medianWaitDays: Number(weightedMedian.toFixed(1)),
    overOneMonthPercent: totalAppointments > 0
      ? Number(((overOneMonth / totalAppointments) * 100).toFixed(1))
      : 0,
  };
}
